import { Injectable, Inject } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import SHA1 from 'crypto-js/sha1';
import AES from 'crypto-js/aes';
import CryptoUTF8 from 'crypto-js/enc-utf8';
import { CookieService } from 'ngx-cookie-service';

interface Session {
    token: string;
    refreshToken: string;
}

interface UserDetails {
    id: number;
    idCompany: number;
    email: string;
    fullName: string;
    language: string;
    currency: string;
    toursToExecute: string[];
    wizardFinished: boolean;
}

const privateKeySession = 'P(6u4*Io2K3L5#WQ7HnEf(*HP@Oqw3ai';
const privateKeyDetails = '$gE3dF@DGzr%vf5jSwd2#eDlih%Hore6';
const privateKeyCookies = '@D4w%Ge#S4f$RE%2Hs3@!DoF3Y!j6R#k';
const privateSecretKey = '!T5a@Hh43%b$d3@2%a1#1gDe7Q@b1Qjl';
const userDetailsEmpty: UserDetails = {
    id: 0,
    idCompany: 0,
    email: "",
    fullName: "",
    language: "",
    currency: "",
    toursToExecute: [],
    wizardFinished: false
}
@Injectable({
    providedIn: 'root'
})
export class SessionService {
    private session: Session | undefined;

    constructor(
        @Inject(LOCAL_STORAGE) private storage: StorageService,
        private cookieService: CookieService
    ) { }

    private get KeySession() {
        return SHA1(privateKeySession).toString();
    }

    private get KeyDetails() {
        return SHA1(privateKeyDetails).toString();
    }

    private get SecretKey() {
        return SHA1(privateSecretKey).toString();
    }

    private get KeyCookies() {
        return SHA1(privateKeyCookies).toString();
    }

    get isLogged(): boolean {
        let hasSession: boolean = this.cookieService.check(this.KeySession);
        if (hasSession) {
            const json: string = this.cookieService.get(this.KeySession);
            var bytes = AES.decrypt(json, this.SecretKey);
            this.session = JSON.parse(bytes.toString(CryptoUTF8));
        }
        return hasSession;
    }

    setToken(ses: Session): void {
        const session: Session = ses;
        this.cookieService.set(this.KeySession, AES.encrypt(JSON.stringify(session), this.SecretKey).toString());
    }

    setDetails(details: UserDetails) {
        this.cookieService.set(this.KeyDetails, AES.encrypt(JSON.stringify(details), this.SecretKey).toString());
    }

    setWizardFinishedDetail(wizardFinished: boolean) {
        const details = this.getDetails();
        details.wizardFinished = wizardFinished;
        this.setDetails(details);
    }

    getDetails(): UserDetails {
        const json: string = this.cookieService.get(this.KeyDetails);
        if (!json)
            return userDetailsEmpty; 
        try {
            var bytes = AES.decrypt(json, this.SecretKey);
            return JSON.parse(bytes.toString(CryptoUTF8));
        } catch (error) {
            console.error('Error parsing JSON at getDetails():', error);
            return userDetailsEmpty; 
        }
    }
    
    changeLanguageDetails(languageCode: string) {
        let details = this.getDetails();
        details.language = languageCode;
        this.setDetails(details);
    }

    changeCurrencyDetails(currencyCode: string) {
        let details = this.getDetails();
        details.currency = currencyCode;
        this.setDetails(details);
    }

    get token(): string {
        if (this.isLogged && this.session) {
            return this.session.token
        }
        return "";
    }

    logout(): void {
        this.cookieService.delete(this.KeyDetails);
        this.cookieService.delete(this.KeySession);
    }

    acceptCookies(): void {
        this.storage.set(this.KeyCookies, 1);
    }

    verifyIfCookiesAreAccepted(): boolean {
        let hasCookie: boolean = this.storage.has(this.KeyCookies);
        if (hasCookie) {
            return this.storage.get(this.KeyCookies) == 1 ? true : false;
        }
        return false;
    }

    getCompanyStatusAndIfItHasTrialPeriod() {
        
    }
}
